import api from '../AxiosConfig';

export const getAllUsers = async () => {
    try {
        const response = await api.get('/admin/get-users', {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const getUserById = async (userId) => {
    try {
        const response = await api.get(`/admin/users/${userId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching user:', error);
        throw error;
    }
};

export const createUser = async (userData) => {
    try {
        const response = await api.post('/admin/users', userData, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
};

export const updateUser = async (userId, userData) => {
    try {
        const response = await api.put(`/admin/users/${userId}`, userData, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error updating user:', error);
        throw error;
    }
};

export const deleteUser = async (userId) => {
    try {
        const response = await api.delete(`/admin/users/${userId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting user:', error);
        throw error;
    }
};

export const toggleUserStatus = async (userId, isActive) => {
    try {
        const response = await api.patch(`/admin/users/${userId}/status`,
            { isActive },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error toggling user status:', error);
        throw error;
    }
};

export const registerUserAdmin = async (userData) => {
    try {
        const response = await api.post('/admin/register-user', userData, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error registering user:', error);
        throw error;
    }
};

// Subscription Types Management
export const getAllSubscriptionTypes = async () => {
    try {
        const response = await api.get('/admin/subscription-types', {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching subscription types:', error);
        throw error;
    }
};

export const getSubscriptionTypeById = async (subscriptionTypeId) => {
    try {
        const response = await api.get(`/admin/subscription-types/${subscriptionTypeId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching subscription type:', error);
        throw error;
    }
};

export const createSubscriptionType = async (subscriptionTypeData) => {
    try {
        const response = await api.post('/admin/subscription-types', subscriptionTypeData, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error creating subscription type:', error);
        throw error;
    }
};

export const updateSubscriptionType = async (subscriptionTypeId, subscriptionTypeData) => {
    try {
        const response = await api.put(`/admin/subscription-types/${subscriptionTypeId}`, subscriptionTypeData, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error updating subscription type:', error);
        throw error;
    }
};

export const deleteSubscriptionType = async (subscriptionTypeId) => {
    try {
        const response = await api.delete(`/admin/subscription-types/${subscriptionTypeId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting subscription type:', error);
        throw error;
    }
};

// Subscription Management
export const getAllSubscriptions = async (params = {}) => {
    try {
        const queryParams = new URLSearchParams(params).toString();
        const url = queryParams ? `/admin/subscriptions?${queryParams}` : '/admin/subscriptions';

        const response = await api.get(url, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching subscriptions:', error);
        throw error;
    }
};

export const getSubscriptionById = async (subscriptionId) => {
    try {
        const response = await api.get(`/admin/subscriptions/${subscriptionId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching subscription:', error);
        throw error;
    }
};

export const getSubscriptionsByUser = async (userId) => {
    try {
        const response = await api.get(`/admin/users/${userId}/subscriptions`, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching user subscriptions:', error);
        throw error;
    }
};

export const createSubscription = async (subscriptionData) => {
    try {
        const response = await api.post('/admin/subscriptions', subscriptionData, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error creating subscription:', error);
        throw error;
    }
};

export const updateSubscription = async (subscriptionId, subscriptionData) => {
    try {
        const response = await api.put(`/admin/subscriptions/${subscriptionId}`, subscriptionData, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        console.log(response)
        return response.data;
    } catch (error) {
        console.error('Error updating subscription:', error);
        throw error;
    }
};

export const cancelSubscription = async (subscriptionId, reason = null) => {
    try {
        const requestData = reason ? { reason } : {};
        const response = await api.patch(`/admin/subscriptions/${subscriptionId}/cancel`, requestData, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error cancelling subscription:', error);
        throw error;
    }
};

export const extendSubscription = async (subscriptionId, days) => {
    try {
        const response = await api.patch(`/admin/subscriptions/${subscriptionId}/extend`, { days }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error extending subscription:', error);
        throw error;
    }
};

export const deleteSubscription = async (subscriptionId) => {
    try {
        const response = await api.delete(`/admin/subscriptions/${subscriptionId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting subscription:', error);
        throw error;
    }
};
